module.exports = __webpack_public_path__ + "static/media/facebook.dcacd6a9.svg";